import ApiClient from './ApiClient';

export const getStampHistory = async (companyCode: string, orgCode: string,
  targetDateFrom: string, targetDateTo:string): Promise<any> => {
  const params = {
    orgCode,
    targetDateFrom,
    targetDateTo,
  };
  const response = await ApiClient.get(`/v1/attendStamp/historyForRange/${companyCode}`, params);
  return response.data;
};

export const getGpsStampHistory = async (companyCode: string, orgCode: string, staffCode: string,
  targetDateFrom: string, targetDateTo:string): Promise<any> => {
  const params = {
    orgCode,
    staffCode,
    targetDateFrom,
    targetDateTo,
  };
  const response = await ApiClient.get(`/v1/attendStamp/gpsHistory/${companyCode}`, params);
  return response.data;
};


export const getSearchDateClosing = async (companyCode: string): Promise<any> => {
  const staffCode = sessionStorage.getItem('loginUser.staffCode') || '';
  const response = await ApiClient.get(`/v1/employments/searchDate/${companyCode}?staffCode=${staffCode}&closeDateFlg=false&targetDate=`, {});

  return response.data;
};

export default getStampHistory;
